
const getLocalStorage = (...args) => {
  let storage = {};
  for (let arg of args) {
    storage[arg] = window.localStorage.getItem(arg) || "";
  }
  return storage;
}
const getSessionStorage = (...args) => {
  let storage = {};
  for (let arg of args) {
    storage[arg] = window.sessionStorage.getItem(arg) || "";
  }
  return storage;
}

const setLocalStorage = (data) => {
  for (let prop in data) {
    window.localStorage.setItem(prop, data[prop]);
  }
}
const setSessionStorage = (data) => {
  for (let prop in data) {
    window.sessionStorage.setItem(prop, data[prop]);
  }
}

const removeLocalStorage = (...args) => {
  for (let arg of args) {
    window.localStorage.removeItem(arg);
  }
}
const removeSessionStorage = (...args) => {
  for (let arg of args) {
    window.sessionStorage.removeItem(arg);
  }
}


const debounce = (func, wait, immediate) => {
  let timeout, args, context, timestamp, result;
  return function () {
    context = this;
    args = arguments;
    timestamp = new Date();
    const later = () => {
      const last = (new Date()) - timestamp;
      if (last < wait) {
        timeout = setTimeout(later, wait - last);
      } else {
        timeout = null;
        result = func.apply(context, args);
      }
    };
    if (!timeout) {
      timeout = setTimeout(later, wait);
    }
    return result;
  };
}
const throttle = (func, wait, options) => {
  var timeout, context, args, result;
  var previous = 0;
  if (!options) options = {};

  var later = function () {
    previous = options.leading === false ? 0 : new Date();
    timeout = null;
    result = func.apply(context, args);
    if (!timeout) context = args = null; //显示地释放内存，防止内存泄漏
  };

  var throttled = function () {
    var now = new Date();
    if (!previous && options.leading === false) previous = now;
    var remaining = wait - (now - previous);
    context = this;
    args = arguments;
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = now;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining);
    }
    return result;
  };

  throttled.cancel = function () {
    clearTimeout(timeout);
    previous = 0;
    timeout = context = args = null;
  };

  return throttled;
}

const getLocationParam = function (name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return decodeURIComponent(r[2]); return "";
}

const toChinesNum = num => {
  var arr1 = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
  var arr2 = [
    "",
    "十",
    "百",
    "千",
    "万",
    "十",
    "百",
    "千",
    "亿",
    "十",
    "百",
    "千",
    "万",
    "十",
    "百",
    "千",
    "亿"
  ];
  if (!num || isNaN(num)) return "零";
  var english = num.toString().split("");
  var result = "";
  for (var i = 0; i < english.length; i++) {
    var des_i = english.length - 1 - i; // 倒序排列设值
    result = arr2[i] + result;
    var arr1_index = english[des_i];
    result = arr1[arr1_index] + result;
  }
  result = result.replace(/零(千|百|十)/g, "零").replace(/十零/g, "十"); // 将【零千、零百】换成【零】 【十零】换成【十】
  result = result.replace(/零+/g, "零"); // 合并中间多个零为一个零
  result = result.replace(/零亿/g, "亿").replace(/零万/g, "万"); // 将【零亿】换成【亿】【零万】换成【万】
  result = result.replace(/亿万/g, "亿"); // 将【亿万】换成【亿】
  result = result.replace(/零+$/, ""); // 移除末尾的零
  // 将【一十】换成【十】
  result = result.replace(/^一十/g, "十");
  return result;
};

export {
  getLocalStorage,
  setLocalStorage,
  removeLocalStorage,
  getLocationParam,
  debounce,
  throttle,
}

export default {
  install(Vue) {
    Object.defineProperties(Vue.prototype, {
      $util: {
        value: {
          getLocalStorage,
          setLocalStorage,
          removeLocalStorage,
          getSessionStorage,
          getLocationParam,
          setSessionStorage,
          removeSessionStorage,
          debounce,
          throttle,
          toChinesNum
        }
      }
    })
  }
}
/* 生成当前时间戳对应的62进制形式短链接 */
export const shorten = function () {
  var DIGITS = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'
  var seq = new Date().getTime()
  var len = DIGITS.length
  var arr = []
  do {
    arr.unshift(DIGITS.charAt(seq % len))
    seq = parseInt(seq / len)
  } while (seq !== 0)
  return arr.join('')
}




// WEBPACK FOOTER //
// ./src/assets/js/util.js